<div class="card">
  <div class="card-body">
    <h5 class="mb-4">Patient Demographics</h5>

    <div class="row phi">
      <div class="col">
        <strong>FIRST NAME:</strong>
        <div>{{ patient.firstName }}</div>
      </div>

      <div class="col">
        <strong>LAST NAME:</strong>
        <div>{{ patient.lastName }}</div>
      </div>

      <div class="col">
        <strong>DOB:</strong>
        <div>{{ patient.dob |  date: 'MM/dd/yyyy' }}</div>
      </div>

      <div class="col">
        <strong>GENDER:</strong>
        <div>{{ patient.gender | gender }}</div>
      </div>

      <div class="col">
        <strong>EMPI:</strong>
        <div>
          {{ patient.empi | blankValueDash }}
        </div>
      </div>

      <div class="col">
        <strong>EHR INSTANCE:</strong>
        <div>{{ patient.ehrInstance | blankValueDash }}</div>
      </div>

      @if (patient.hasSsn) {
        <div class="col">
          <strong>SSN:</strong>
          <div>
            <app-sensitive-string
              (valueAccessed)="onSsnAccessed(patient.id)"
              [value]="patient.decryptedSsn"
              [hiddenTextLength]="12" />
          </div>
        </div>
      }
    </div>

    @if (patient.alternateNames.length > 0) {
      <div class="row mt-3 phi">
        <div class="col">
          <strong>OTHER NAME(S)</strong>
          <div>
            @for (alternateName of patient.alternateNames; track alternateName) {
              <div>{{ alternateName }}</div>
            }
          </div>
        </div>
      </div>
    }

    @if (patient.insuranceIdentifiers.length > 0) {
      <div class="row mt-3 phi">
        <div class="col">
          <strong>INSURANCE MEMBER ID:</strong>
          <div>
            @for (insuranceIdentifier of patient.insuranceIdentifiers; track insuranceIdentifier) {
              <div>
                {{ insuranceIdentifier }}
              </div>
            }
          </div>
        </div>
      </div>
    }

    <div class="row mt-3 phi">
      @if (patient.phoneNumbers.length > 0) {
        <div class="col">
          <strong>PHONE NUMBER:</strong>
          <div>
            @for (phoneNumber of patient.phoneNumbers; track phoneNumber) {
              <div>
                <app-phone-number [number]="phoneNumber" />
              </div>
            }
          </div>
        </div>
      }
    </div>

    <div class="row mt-3 phi">
      @if (patient.addresses.length > 0) {
        <div class="col">
          <strong>ADDRESS:</strong>
          <div>
            @for (address of patient.addresses; track address) {
              <div class="mb-2">
                <div>{{ address.line1 }}</div>
                <div>{{ address.line2 }}</div>
                <div>{{ address.city }}, {{ address.state }} {{ address.zip }}</div>
              </div>
            }
          </div>
        </div>
      }
    </div>

    <div class="row mt-3 phi">
      @if (patient.otherEhrMrns.length > 0) {
        <div class="col">
          <strong>OTHER EHR MRN(S):</strong>
          <div>
            @for (otherEhrMrn of patient.otherEhrMrns; track otherEhrMrn) {
              <div class="mb-2">
                <div class="phi">{{ otherEhrMrn.ehr}}:{{ otherEhrMrn.mrn }}</div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
